import { queryOptions } from '@tanstack/react-query';

import { supportApi } from '../apis/support';

export const supportQueries = {
  tutorials: (language: string) =>
    queryOptions({
      queryKey: ['support', 'tutorials', language],
      queryFn: supportApi.getTutorials,
    }),
  precifieldUsers: queryOptions({
    queryKey: ['support', 'precifield-users'],
    queryFn: supportApi.getPrecifieldUsers,
  }),
};
